<template>
  <div>
    <div id="page-header">
      <div align="left">
        <img alt="InCrowd logo" id="logo" src="@/assets/logo.png" />
      </div>
      <div align="right">
        <button class="header-buttons" @click.prevent="logout">Log out</button>
        <a :href="latestVersionUrl" target="_blank" class="download-cast-button">Download the latest version of Cast</a>
      </div>
    </div>

    <div id="header-separator" />
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$emit('log-out')
    }
  },
  props: {
    latestVersionUrl: String
  }
}
</script>

<style>
#logo {
  float: left;
  margin-left: 28px;
  margin-top: 9px;
}
@media screen and (max-width: 475px) {
  #logo {
    width: 159px;
  }
}
.header-buttons {
  float: right;
  margin-right: 24px;
  margin-top: 12px;
  height: 38px;

  background: rgba(73, 76, 85, 1);

  border: 0px;
  border-radius: 4px;
}
.download-cast-button {
  line-height: 60px;
  margin-right: 8px;
}
#header-separator {
  border-bottom: 1px solid rgba(89, 92, 102, 1);
  box-sizing: border-box;
  border-radius: 4px;
}
</style>